'use client';

import { Icon, Button, ButtonProps } from '@chakra-ui/react';
import { ICONS } from '~/constants';

interface EditButtonProps extends ButtonProps {
  onClick: () => void;
  label?: string;
}

/**
 * A reusable edit button component with consistent styling
 *
 * @param onClick Function to call when the button is clicked
 * @param label Optional label for the button (defaults to "Redigera")
 * @param props Additional ButtonProps to pass to the component
 */
export const EditButton = ({
  onClick,
  label = 'Redigera',
  size,
  ...props
}: EditButtonProps) => {
  return (
    <Button
      variant="subtle"
      onClick={onClick}
      {...props}
    >
      <Icon as={ICONS.EDIT_INFO} />
    </Button>
  );
};
